import React from 'react';
import { Phone, Envelope, FacebookLogo, InstagramLogo, WhatsappLogo } from '@phosphor-icons/react';
import { BRAND } from '@/theme/brand';

const TopBar = () => (
  <div className="bg-[#1B2D5E] text-white h-9 px-6">
    <div className="max-w-7xl mx-auto h-full flex flex-wrap justify-between items-center gap-2 text-[12px] font-body" style={{ color: 'rgba(255,255,255,0.85)' }}>
      <div className="flex items-center gap-3 flex-wrap">
        <a href={`tel:${BRAND.contact.phone}`} className="flex items-center gap-1.5 hover:text-white transition-colors">
          <Phone size={14} weight="fill" />
          <span>{BRAND.contact.phoneDisplay}</span>
        </a>
        <span className="hidden sm:inline opacity-40">|</span>
        <a href={`mailto:${BRAND.contact.email}`} className="hidden sm:flex items-center gap-1.5 hover:text-white transition-colors">
          <Envelope size={14} />
          <span>{BRAND.contact.email}</span>
        </a>
      </div>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <a href="#" aria-label="Facebook" className="hover:text-white transition-colors">
            <FacebookLogo size={16} weight="fill" />
          </a>
          <a href="#" aria-label="Instagram" className="hover:text-white transition-colors">
            <InstagramLogo size={16} weight="fill" />
          </a>
          <a
            href={`https://wa.me/${BRAND.contact.phone}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            className="hover:text-white transition-colors"
          >
            <WhatsappLogo size={16} weight="fill" />
          </a>
        </div>
        <span className="hidden md:inline opacity-40">|</span>
        <span className="hidden md:inline font-medium">24/7 Service Available</span>
      </div>
    </div>
  </div>
);

export default TopBar;
